// src/components/layout/PageLayout.tsx
// ============================================================
// Summit League v2 — Page Layout Wrapper
// Renders Navbar + page content. Wrap routes that need the
// navbar with this component. Routes like AuthPage that should
// be fullscreen simply don't use PageLayout.
// ============================================================

import React from 'react';
import Navbar from './Navbar';

interface PageLayoutProps {
  children: React.ReactNode;
}

export default function PageLayout({ children }: PageLayoutProps) {
  return (
    <>
      <Navbar />
      <main>{children}</main>
    </>
  );
}